// extracted by mini-css-extract-plugin
export default {"panel":"tradeActivity_panel__pkSLr","panelHeader":"tradeActivity_panelHeader__qUHiv","panelContent":"tradeActivity_panelContent__d1dpw"};